export class ResponsiveImages{
	init($sections){
		let imagesSrc 	= $sections.find('.js-image-src'),
				windowSize 	= $(window).width() <= 720 ? 'mobile' : 'desktop';

		for(var i = imagesSrc.length; i--;){
			var item = $(imagesSrc[i]);
			if(item.data('src-type') === 'background'){
				item.css({'background-image': 'url("'+item.data('image-src-'+windowSize)+'")'});
			}else{
				item.attr('src', item.data('image-src-'+windowSize));
			}
		}
	}
}